export const downloadFormatHandler = (
  mediaType: string | undefined,
  isVideo: boolean | undefined,
  selectedFormat?: string
) => {
  if (selectedFormat) {
    return selectedFormat;
  }
  if (mediaType === 'video' || isVideo) {
    return 'mp4';
  }
  return 'jpg';
};
